import * as React from "react";
const DocumentWithPen = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#3F3F3F", d: "M24.2 24.3V.5L.5 24.3z" }),
        React.createElement("path", { fill: "#CFCFCF", d: "M71.7.5H24.2v23.8H.5v71.2h71.2V.5" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M55.605 44.77 44.433 55.942l33.445 33.446 11.173-11.172z" }),
        React.createElement("path", { fill: "#ED0000", d: "M89.041 78.141 77.87 89.314l5.87 5.868L94.91 84.01zM38.8 39.1l16.8 5.6-11.2 11.2z" }))));
export default DocumentWithPen;
//# sourceMappingURL=DocumentWithPen.js.map